import { render, staticRenderFns } from "./deptListRadio.vue?vue&type=template&id=e0b189c4&"
import script from "./deptListRadio.vue?vue&type=script&lang=js&"
export * from "./deptListRadio.vue?vue&type=script&lang=js&"
import style0 from "./deptListRadio.vue?vue&type=style&index=0&id=e0b189c4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports